import type { PasskeyRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { uuidValueObject } from '@contexts/shared/domain';

export type DeletePasskeyInput = {
	passkeyId: string;
};

export type DeletePasskeyUseCase = UseCase<DeletePasskeyInput, string>;

export function deletePasskeyBuilder(passkeyRepository: PasskeyRepository): DeletePasskeyUseCase {
	return async function deletePasskey(input: DeletePasskeyInput): Promise<string> {
		const passkeyId = uuidValueObject().validate('passkeyId', input.passkeyId);

		return passkeyRepository.deletePasskey(passkeyId);
	};
}
